import React, { useEffect, useState } from 'react';
import Navigation from './header/Navigation';
import Footer from './Footer';
import '../style/btDetails.css';

const data = [
    {
        id: 'nsc',
        name: '那受村',
        coords: "309, 249, 398, 329, 327, 391, 261, 344, 303, 334, 320, 312, 345, 309, 299, 278",
        map: require('../assets/nsc_map.png'),
        text: '那受村位于育才生态区东部山区，东至南岛，西到马脚，北接那会，南靠马亮。全村土地面积约有8000多亩 ，其中耕地面积2431亩，林地面积4158 亩，其他农用地面积1411亩。全村共8个村小组，总人口521户2463人，其中:黎族2060人，占比83.6%，苗族403人占比16.4%。',
        pic: [require('../assets/nsc_pic1.jpg'), require('../assets/nsc_pic2.jpg'), require('../assets/nsc_pic3.jpg'), require('../assets/nsc_pic4.jpg'), require('../assets/nsc_pic5.jpg'), require('../assets/nsc_pic6.jpg')]
    },
    {
        id: 'lmc',
        name: '龙密村',
        coords: "218, 402, 254, 396, 277, 416, 314, 415, 340, 465, 330, 477, 231, 461, 198, 462, 188, 450, 188, 464, 175, 454, 160, 450, 130, 430, 146, 414, 159, 428, 183, 429, 192, 445, 205, 440, 209, 461, 230, 460, 229, 447, 241, 446, 216, 419",
        map: require('../assets/lmc_map.png'),
        text: '龙密村总面积9.97平方公里，耕地面积2627 亩，其中水田面积1955亩，坡园地面积6000亩，其他（水塘、草地）150亩。下辖15个自然村，673户3273人；主要以种植芒果、槟榔、香蕉、冬季瓜菜，养殖鸡、鸭、黑山羊及外出务工为主要经济收入来源，2020年村集体收入8.93万元，人均纯收入13720元。',
        pic: [require('../assets/lmc_pic1.jpg'), require('../assets/lmc_pic2.jpg'), require('../assets/lmc_pic3.jpg'), require('../assets/lmc_pic4.jpg')]
    },
    {
        id: 'mlc',
        name: '马亮村',
        coords: "243, 396, 255, 376, 270, 375, 274, 360, 287, 360, 327, 391, 314, 413, 283, 413, 255, 396, 243, 397",
        map: require('../assets/mlc_map.png'),
        text: '马亮村位于育才生态区西面，距离区管委约4.8公里，马亮村辖区面积5.44平方千米，确权的土地面积3444.97亩，其中耕地1445.01亩，林地1705.96亩，其他294亩，主要种植水稻、冬季瓜菜、槟榔、芒果等作物。全村共8个自然村9个村民小组，总人口415户1950人。',
        pic: [require('../assets/mlc_pic1.jpg'), require('../assets/mlc_pic2.jpg'), require('../assets/mlc_pic3.jpg')]
    },
    {
        id: 'mjc',
        name: '马脚村',
        coords: "195, 326, 209, 357, 241, 376, 243, 355, 263, 347, 277, 357, 270, 376, 250, 378, 242, 397, 204, 398, 193, 416, 156, 406, 167, 371, 188, 366, 188, 338",
        map: require('../assets/mjc_map.png'),
        text: '马脚村，因大力神神话故事“马脚印”而得名，位于三亚市育才生态区中部，S314省道横穿马脚村，距三亚市主城区45公里，距三亚凤凰机场33公里。辖区总面积约15.16平方公里，全村土地面积8687亩，其中耕地面积2337亩，林地面积5050亩，其他农用地面积1300亩。农民主要依靠种植芒果、槟榔、诺丽果、水稻等作物，全村人均年收入12800元。下辖8个村小组，常住总人口536户2539人，其中黎族2508人，占比近99%。',
        pic: [require('../assets/mjc_pic1.jpg'), require('../assets/mjc_pic2.png')]
    },
    {
        id: 'nhc',
        name: '那会村',
        coords: "326, 245, 350, 190, 413, 151, 432, 194, 448, 202, 428, 213, 389, 311",
        map: require('../assets/nhc_map.png'),
        text: '那会村位于育才生态区北部，辖区面积26.9平方公里，共6个村小组，总人口250户1265人。全村耕地面积259亩，林地面积约19200亩。现阶段主要以农业生产为主导产业，以种植橡胶、槟榔、芒果、冬季瓜菜为主，同时大力发展鸡、鸭等禽畜养殖业及林下种植经济。',
        pic: [require('../assets/nhc_pic1.jpg'), require('../assets/nhc_pic2.jpg'), require('../assets/nhc_pic3.jpg'), require('../assets/nhc_pic4.jpg'), require('../assets/nhc_pic6.jpg'), require('../assets/nhc_pic8.jpg'), require('../assets/nhc_pic10.jpg'), require('../assets/nhc_pic12.jpg'), require('../assets/nhc_pic13.jpg')]
    },
    {
        id: 'ylc',
        name: '雅亮村',
        coords: "107, 301, 144, 311, 173, 283, 192, 308, 141, 391, 119, 381, 124, 352, 100, 330",
        map: require('../assets/ylc_map.png'),
        text: '雅林村地处育才生态区西北部，距离育才生态区管委会约19公里，西面与乐东县富保农场相连，南面与南滨农场接壤。四周环山，森林茂密属丘陵地山区，盆地状，平均海拔为450米，最高海拔为820米，全村土地面积22025亩，其中耕地3891亩，林地3138亩，其他农用地约14000亩，两宗水库。全村共18个村民小组，户籍人口1037户4257人，常住人口845户3933人，以黎族为主。',
        pic: [require('../assets/ylc.jpg')]
    },
    {
        id: 'qfc',
        name: '青法村',
        coords: "106, 299, 144, 309, 172, 281, 203, 293, 261, 257, 266, 248, 249, 244, 233, 254, 223, 217, 197, 213, 175, 238, 165, 233, 159, 245, 117, 239",
        map: require('../assets/qfc_map.png'),
        text: '青法村位于三亚市育才生态区西北部，东邻大隆水库，南接雅亮村委会，西至雅林村委会，北接明善村委会和保国农场，总面积15.5平方公里。全村共有6个自然村9个村民小组，总人口416户2293人。可耕种土地9592亩，其中耕地 3161亩，（水田2165亩、旱田996亩），林地4445亩,坡地1551亩，其它地435亩。村民经济收入主要以种养为主，外出或者灵活务工、加工业酿酒为辅。种植业主要种芒果、槟榔、橡胶、水稻、冬季瓜菜、花生等；养殖业主要养生猪、鸡、山羊、乳鸽等。',
        pic: [require('../assets/qfc_pic1.jpg'), require('../assets/qfc_pic2.jpg'), require('../assets/qfc_pic3.jpg'), require('../assets/qfc_pic4.jpg')]
    },
    {
        id: 'msc',
        name: '明善村',
        coords: "115, 237, 150, 246, 166, 233, 176, 237, 198, 212, 174, 176, 131, 153, 64, 161, 42, 169, 40, 192, 61, 208, 77, 206",
        map: require('../assets/msc_map.png'),
        text: '明善村位于育才生态区西北部，北邻保国农场，南接青法村，东保国农场九队，西至毫赖岭。全村土地面积为9525亩，其中耕地面积为1365.64亩，林地面积约9320亩，其他农用地面积5000多亩，下辖8个村民小组。',
        pic: [require('../assets/msc_pic1.jpg'), require('../assets/msc_pic2.jpg'), require('../assets/msc_pic3.jpg'), require('../assets/msc_pic4.jpg'), require('../assets/msc_pic5.jpg')]
    },
    {
        id: 'ylic',
        name: '雅林村',
        coords: "38, 195, 19, 209, 7, 246, 26, 347, 46, 352, 66, 389, 117, 391, 125, 352, 100, 331, 111, 272, 100, 231, 69, 205, 59, 209",
        map: require('../assets/ylic_map.png'),
        text: '雅林村地处育才生态区西北部，距离区管委会行政办公区约19公里，西面与乐东县富保农场相连，南面与南滨农场接壤。四周环山，森林茂密属丘陵地山区，盆地状，平均海拔为450米，最高海拔为820米，全村土地面积22025亩，其中耕地3891亩，林地3138亩，其他农用地约14000亩，两宗水库。全村共18个村民小组，户籍人口1037户4257人，常住人口845户3933人，以黎族为主。',
        pic: [require('../assets/ylic_pic1.jpg'), require('../assets/ylic_pic2.jpg'), require('../assets/ylic_pic3.jpg'), require('../assets/ylic_pic4.jpg'), require('../assets/ylic_pic5.jpg'), require('../assets/ylic_pic6.jpg'), require('../assets/ylic_pic7.jpg')]
    },
    {
        id: 'bac',
        name: '抱安村',
        coords: "264, 175, 276, 239, 307, 116, 378, 77, 449, 15, 473, 68, 493, 122, 420, 149, 390, 173, 357, 182, 318, 249, 293, 241",
        map: require('../assets/bac_map.png'),
        text: '抱安村委会位于三亚市育才生态区西北部，位于三亚与乐东的交界处，是三亚最偏远的乡村之一，距离三亚市内80公里、距离育才生态区管委办公区42公里。是黎族苗族居住的古老村庄，下辖南来、抱安、抱安二、保文、保文二、保文三等6个村小组，共261户1326人。',
        pic: [require('../assets/bac_pic1.jpg'), require('../assets/bac_pic2.jpg'), require('../assets/bac_pic3.jpg'), require('../assets/bac_pic4.jpg'), require('../assets/bac_pic5.jpg'), require('../assets/bac_pic6.jpg'), require('../assets/bac_pic7.jpg')]
    }
];


function BtDetails() {

    const [curCou, setCurCou] = useState(data[0]);

    useEffect(() => {
        const id = window.location.hash.split('#')[1];
        const d = data.filter(item => item.id === id);
        setCurCou(d[0]);
    }, [window.location.hash])

    return (
        <>
            <Navigation />
            <div className="btDetails">
                <h1 className="btDetails-co">{curCou.name}</h1>
                <div className="lay-title">发展概况</div>
                <div className="btDetails-gk-title">{curCou.text}</div>
                <div className="btDetails-gk-pic">
                    {
                        curCou.pic.map((item, i) =>
                            <img key={i} className="btDetails-gk-pic__img" src={item} alt="村落图片" />
                        )
                    }
                </div>
                {/* <div className="btDetails-gk-main">
                    <img className="btDetails-gk-main_pic" src={bt_gk_map} alt="发展地图" />
                    <p className="btDetails-gk-main_text"> 依托抱龙森林林公园等自然资源优势和黎苗民俗文化，走三产融合发展之路，通过“政府+企业+村民”、“合作社+村民”等多元参与方式，将立新打造为集自然生态、乡村休闲为一体的生态体验基地及以黎苗体验为核心的文化圣地。</p>
                </div>
                <div className="lay-title">产业布局</div>
                <div className="btDetails-cy-main">
                    <div className="btDetails-cy-main__fun">
                        <div className="btDetails-cy-main__fun--item">
                            <div className="item-title">
                                产业发展概括
                        </div>
                            <p className="item-text">建设以村委会为中心的综合产业中心、周边村庄的公共中心、村域第三产业的集中区，包含农产品超市、村民合作社及电子商务站、先进村黎族村落体验等功能。</p>
                        </div>
                        <div className="btDetails-cy-main__fun--item">
                            <div className="item-title">
                                产业发展概括
                        </div>
                            <p className="item-text">建设以村委会为中心的综合产业中心、周边村庄的公共中心、村域第三产业的集中区，包含农产品超市、村民合作社及电子商务站、先进村黎族村落体验等功能。</p>
                        </div>
                    </div>
                    <img className="btDetails-cy-main_pic" src={bt_pro_map} alt="发展地图" />
                </div>
                <div className="lay-title">近期重点项目</div>
                <img className="btDetails-zd_pic" src={bt_bj_map} alt="发展地图" /> */}
            </div>
            <Footer />
        </>
    );
}

export default BtDetails;
